export default __webpack_public_path__ + "static/media/my-web-site.6263413f.jpeg";